import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { PHBHPFeaturePackageInsitutionManagementService } from '../../ph-bhp-feature-package-insitution-management.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { AppConfig } from 'src/app/app.config';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'app-webkess-settings',
  templateUrl: './webkess-settings.component.html',
  styleUrls: ['./webkess-settings.component.css']
})
export class WebkessSettingsComponent implements OnInit, OnDestroy {

  subscription: Subscription;
  institutionId: number;
  institutionData: any;
  userList: [any];
  itemChange = false;
  deleteDataItem;
  modalRef: BsModalRef;
  myGroup = new UntypedFormGroup({
    activateWebKess: new UntypedFormControl(null),
    activateObservation: new UntypedFormControl(null),
    activateConsumption: new UntypedFormControl(null)
  });

  settingsGroup = new UntypedFormGroup({
    KHCode: new UntypedFormControl(''),
    CHCUsername: new UntypedFormControl(''),
    CHCPassword: new UntypedFormControl(''),
  });

  userId: any;
  resFromParticipationCall: any;
  submitted = false;
  khCodeCheck: any;
  hideRequest: boolean;
  currentLang: string;
  consumerKey: string;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  checkStatusIntegrations: any;
  
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private service: PHBHPFeaturePackageInsitutionManagementService,
    public layoutService: PHBHPLayoutPackageService,
    public config: AppConfig,
  ) { }

  ngOnInit() {
    this.currentLang = localStorage.getItem('selectedlanguage');
    this.institutionId = this.activatedRoute.snapshot.parent.params.id;
    this.layoutService.showLoader = true;
    this.getInstitutionDetails();
    this.consumerKey = this.config.consumerKey;
    this.service.checkPendingIntegrations(this.institutionId).subscribe((updatedIntegrations: any) => {});
    this.checkStatusIntegrations = setInterval(() => {
      this.service.checkPendingIntegrations(this.institutionId).subscribe((updatedIntegrations: any) => {});
    }, 60*1000);
    // this.subscription = this.data.lang.asObservable().subscribe((changelang) => {
    //   this.currentLang = changelang;
    //   this.getInstitutionDetails();
    // });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    clearInterval(this.checkStatusIntegrations);
  }

  getWebKessActivationDetails() {
    this.service.getwebKessActivationStatus(this.institutionId).subscribe(
      (data: any) => {
        this.resFromParticipationCall = data;
          this.myGroup.patchValue({
            activateWebKess: data.activateWebKess,
            activateConsumption: data.activateConsumption,
            activateObservation: data.activateObservation
          });
        if (this.resFromParticipationCall.status === 'Enabled' || this.resFromParticipationCall.status === 'Pending') {
          if (this.resFromParticipationCall.activateWebKess) {
            if(this.config.userData.roleName.roleId == 4) {
            this.service.getGeneralConfigurationByInstitutionId(this.institutionId).subscribe(
              (res: any) => {
                if (res) {
                  if (res.khCode) {
                    this.khCodeCheck = true;
                  }
                  this.settingsGroup.patchValue({
                    KHCode: res.khCode,
                    CHCUsername: res.chcUsername,
                    CHCPassword: res.chcPassword,
                  });
                }
                this.service.checkPendingIntegrations(this.institutionId).subscribe(data => { });
                this.layoutService.showLoader = false;
              }
            );}
          } else {
            this.layoutService.showLoader = false;
          }
        } else {
          this.layoutService.showLoader = false;
        }
      }, (err:any)=>{this.layoutService.showLoader = false;},()=>{this.layoutService.showLoader=false;}
    );
  }
  getInstitutionDetails() {
    this.service.GetInstitutionDetails(this.institutionId).subscribe((res: any) => {
      this.institutionData = res;
      this.userId = this.config.userData.userId;
      this.getWebKessActivationDetails();
    });
  }

  backToManageInstitution() {
    this.onChildData('institution');
  }

  ngChangeCheckbox(HandKiss) {
    if (!HandKiss) {
      this.myGroup.patchValue({
        activateObservation: false,
        activateConsumption: false
      });
      this.settingsGroup.get('KHCode').clearValidators();
      this.settingsGroup.get('KHCode').updateValueAndValidity();
      this.settingsGroup.get('CHCUsername').clearValidators();
      this.settingsGroup.get('CHCUsername').updateValueAndValidity();
      this.settingsGroup.get('CHCPassword').clearValidators();
      this.settingsGroup.get('CHCPassword').updateValueAndValidity();
    } else {
      this.settingsGroup.get('KHCode').setValidators([Validators.required]);
      this.settingsGroup.get('KHCode').updateValueAndValidity();
      this.settingsGroup.get('CHCUsername').setValidators([Validators.required]);
      this.settingsGroup.get('CHCUsername').updateValueAndValidity();
      this.settingsGroup.get('CHCPassword').setValidators([Validators.required]);
      this.settingsGroup.get('CHCPassword').updateValueAndValidity();
    }
  }

  onClickSaveParticipation(event) {
    if (this.myGroup.value.activateWebKess) {
      if (!this.myGroup.value.activateObservation && !this.myGroup.value.activateConsumption) {
        if (this.layoutService.isObserveLicense(this.institutionData.institution.institution.packageID)) {
            this.layoutService.showError(this.layoutService.translateText(this.translationKeys.Webkess.SelectConsumption));
        } else {
          this.layoutService.showError(this.layoutService.translateText(this.translationKeys.Webkess.ChooseConsumption));
        }
        return false;
      }
    }
    let submittedValue = {
      activateConsumption : this.myGroup.value.activateConsumption,
      activateObservation : this.myGroup.value.activateObservation,
      activateWebKess : this.myGroup.value.activateWebKess
    }
    if(this.resFromParticipationCall.status == null) {
      if(this.myGroup.value.activateConsumption== false) {
        submittedValue.activateConsumption = null;
      }
      if(this.myGroup.value.activateObservation == false) {
        submittedValue.activateObservation = null;
      }
    }

    if(this.resFromParticipationCall.status == 'Enabled') {
      if(this.resFromParticipationCall.activateConsumption == null && submittedValue.activateConsumption == false) {
        submittedValue.activateConsumption = null;
      }
      if(this.resFromParticipationCall.activateObservation == null && submittedValue.activateObservation == false) {
        submittedValue.activateObservation = null;
      }

    }
 
    this.layoutService.showLoader = true;
    this.service.updateAdditionalChanges(this.institutionId, this.userId, submittedValue, this.currentLang).subscribe(
      (res: any) => {
        this.layoutService.showLoader = false;
        this.hideRequest = true;
        this.resFromParticipationCall.status = 'Pending';
        this.layoutService.showSuccess(this.layoutService.translateText(this.translationKeys.Webkess.SentRequest));
      }
    );
  }

  onClickSaveSettings(event) {
    this.submitted = true;
    if (this.settingsGroup.invalid) {
      return;
    }
    const postValue = {
      'institutionID': this.institutionId,
      'khCode': this.settingsGroup.value.KHCode,
      'consumerKey': this.consumerKey,
      'chcUsername': this.settingsGroup.value.CHCUsername,
      'chcPassword': this.settingsGroup.value.CHCPassword,
      'IswebKessConnectionEstablished': 1,
      'enableHandKissSurveillance': 1
    };
    this.layoutService.showLoader = true;
    this.service.webKessTestConnection(this.institutionId, postValue).subscribe(
      (data: String) => {
        if (data == "OK") {
          this.service.UpdateGeneralConfigurationSettings(this.institutionId, postValue).subscribe(
            (res: any) => {
              this.layoutService.showLoader = false;
              this.layoutService.showSuccess(this.layoutService.translateText(this.translationKeys.Webkess.EstablishedConnection));
              this.khCodeCheck = true;
            }
          );
        
        } else if (data == "ERROR_CREDENTIALS") {
          this.layoutService.showLoader = false;
          this.layoutService.showError(this.layoutService.translateText(this.translationKeys.Webkess.EnterValidSettings));
        } else if (data == "ERROR_KHCODE_NOTEXIST")  {
          this.layoutService.showLoader = false;
          this.layoutService.showError(this.layoutService.translateText(this.translationKeys.Webkess.EnterValidKhcode));
        } else if (data == "ERROR_KHCODE_DUPLICATED")  {
          this.layoutService.showLoader = false;
          this.layoutService.showError(this.layoutService.translateText(this.translationKeys.Webkess.KhcodeDuplicated));
        } else {
          this.layoutService.showLoader = false;
          this.layoutService.showError(this.layoutService.translateText(this.translationKeys.Webkess.ErrorTestingConnection));
        }
      }
      , err=>{
      console.log(err);
      this.layoutService.showLoader = false;
      this.layoutService.showError(this.layoutService.translateText(this.translationKeys.Webkess.SaveCredentials));
    });
  }

  onChildData(emitter) {
    this.router.navigate([emitter]);
  }

  isObserveLicense(packageId) {
    return this.layoutService.isObserveLicense(packageId);
  }

}
